module.exports = __webpack_public_path__ + "static/media/pikachu-loader.4a470171.gif";